// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { DealData, JacketType } from '@interfaces/deal.interfaces';
import { DealsService } from '@services/deals.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DealsResolver implements Resolve<DealData> {
    constructor(private dealsService: DealsService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<DealData> {
        let records = undefined;
        if (state.url === '/dashboard/deals') {
            const storedPageSize = this.dealsService.getTablePageSize(JacketType.Deal);
            if (storedPageSize) {
                records = storedPageSize;
            }
        }
        return this.dealsService.getDealsByType$(JacketType.Deal, records);
    }
}
